/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import Config from 'Config';
import { getToken } from 'common/services/AuthService';
import { Account } from 'common/types';
import { TourData } from './slice';

function getCurrentToken() {
    const token = getToken() as { id: string; user: Account } | undefined;
    if (!token) return null;
    return token.id;
}

function getCurrentVersion() {
    const versions = Config.version.split('.');
    return `v${versions[0]}.${versions[1]}`;
}

function getPreviousVersion() {
    return localStorage.getItem('appPreviousVersion');
}

export function updateVersion() {
    localStorage.setItem('appPreviousVersion', getCurrentVersion());
}

export function isNewVersion() {
    return getCurrentVersion() !== getPreviousVersion();
}

export function startGuideTour(version?: string, forceStart?: boolean) {
    const tourId = version || getCurrentVersion();
    const token = getCurrentToken();
    if (!token) return;
    window.GuideTour?.startTour({ token, tourId, forceStart });
}

export function stopGuideTour() {
    window.GuideTour?.stopTour();
}

export async function getAvailableVersions(): Promise<TourData[]> {
    const token = getCurrentToken();
    if (!token) return [];
    const versions = await window.GuideTour?.getAvailableVersions(token);
    return versions || [];
}

export function startTourWalkThrough(forceStart?: boolean) {
    const token = getCurrentToken();
    if (!token) return;
    window.GuideTour?.startWalkThrough({ token, forceStart });
}
